module.exports = __webpack_public_path__ + "media/images/pic/brodno/video-c46a6ea4db0c58a2dfd276fca0ecb3e2.png";